import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import PaperFreeMonitoringPostReport
  from '../../components/PaperFreeMonitoringPostReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PaperFreeMonitoringPostSummarySelectors';

export function PaperFreeMonitoringPostSummaryContainer(props) {
  return (
    <PaperFreeMonitoringPostReport
      reportId={ReportDefinitions.PAPER_FREE_MONITORING_POST_902_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PaperFreeMonitoringPostSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PaperFreeMonitoringPostSummaryContainer);
